(function () {
  'use strict';

  /* ========================================
   * c-exit-popup.js
   * 離脱検知ロジック + ポップアップ表示制御
   * ======================================== */

  var COOKIE_NAME = 'c_exit_popup_shown';
  var SESSION_KEY = 'c_exit_popup_session';

  /* ---------- ユーティリティ ---------- */

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  function isMobile() {
    return window.innerWidth < 1025;
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days > 0) {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  /* ---------- スクロール検知（SP） ---------- */

  var SENSITIVITY_MAP = {
    low: -150,
    medium: -80,
    high: -40
  };

  function ScrollDetector(opts) {
    this.threshold = SENSITIVITY_MAP[opts.sensitivity] || SENSITIVITY_MAP.medium;
    this.onTrigger = opts.onTrigger;
    this.lastY = window.pageYOffset;
    this.lastTime = Date.now();
    this.ticking = false;
    this._onScroll = this._onScroll.bind(this);
  }

  ScrollDetector.prototype.start = function () {
    window.addEventListener('scroll', this._onScroll, { passive: true });
  };

  ScrollDetector.prototype.stop = function () {
    window.removeEventListener('scroll', this._onScroll);
  };

  ScrollDetector.prototype._onScroll = function () {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this._calc.bind(this));
  };

  ScrollDetector.prototype._calc = function () {
    var currentY = window.pageYOffset;
    var currentTime = Date.now();
    var deltaY = currentY - this.lastY;
    var deltaT = currentTime - this.lastTime;

    if (deltaT > 0) {
      var velocity = (deltaY / deltaT) * 100; // px per 100ms

      // ページ上部30%以内では発火しない
      var pageHeight = document.documentElement.scrollHeight;
      var viewportHeight = window.innerHeight;
      var scrollableHeight = pageHeight - viewportHeight;
      var scrollPercent = scrollableHeight > 0 ? currentY / scrollableHeight : 0;

      if (velocity < this.threshold && scrollPercent > 0.3) {
        this.onTrigger();
        this.stop();
      }
    }

    this.lastY = currentY;
    this.lastTime = currentTime;
    this.ticking = false;
  };

  /* ---------- マウスリーブ検知（PC） ---------- */

  function MouseDetector(opts) {
    this.onTrigger = opts.onTrigger;
    this._onMouseOut = this._onMouseOut.bind(this);
  }

  MouseDetector.prototype.start = function () {
    document.addEventListener('mouseout', this._onMouseOut);
  };

  MouseDetector.prototype.stop = function () {
    document.removeEventListener('mouseout', this._onMouseOut);
  };

  MouseDetector.prototype._onMouseOut = function (e) {
    if (e.clientY < 0 && e.relatedTarget == null) {
      this.onTrigger();
      this.stop();
    }
  };

  /* ---------- スワイプハンドラ（SP） ---------- */

  function SwipeHandler(sheet, onClose) {
    this.sheet = sheet;
    this.onClose = onClose;
    this.startY = 0;
    this.currentY = 0;
    this.isDragging = false;
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);
  }

  SwipeHandler.prototype.start = function () {
    var handle = this.sheet.querySelector('[data-exit-handle]');
    if (handle) {
      handle.addEventListener('touchstart', this._onTouchStart, { passive: true });
    }
    this.sheet.addEventListener('touchmove', this._onTouchMove, { passive: false });
    this.sheet.addEventListener('touchend', this._onTouchEnd);
  };

  SwipeHandler.prototype.stop = function () {
    var handle = this.sheet.querySelector('[data-exit-handle]');
    if (handle) {
      handle.removeEventListener('touchstart', this._onTouchStart);
    }
    this.sheet.removeEventListener('touchmove', this._onTouchMove);
    this.sheet.removeEventListener('touchend', this._onTouchEnd);
  };

  SwipeHandler.prototype._onTouchStart = function (e) {
    this.startY = e.touches[0].clientY;
    this.isDragging = true;
    this.sheet.style.transition = 'none';
  };

  SwipeHandler.prototype._onTouchMove = function (e) {
    if (!this.isDragging) return;
    this.currentY = e.touches[0].clientY;
    var delta = this.currentY - this.startY;
    if (delta > 0) {
      e.preventDefault();
      this.sheet.style.transform = 'translateY(' + delta + 'px)';
    }
  };

  SwipeHandler.prototype._onTouchEnd = function () {
    if (!this.isDragging) return;
    this.isDragging = false;
    var delta = this.currentY - this.startY;
    this.sheet.style.transition = '';

    if (delta > 50) {
      this.onClose();
    } else {
      this.sheet.style.transform = '';
    }
  };

  /* ---------- クーポンコピー ---------- */

  function initCouponCopy(root) {
    var btns = root.querySelectorAll('[data-coupon-copy]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var codeEl = btn.closest('.c-exit-popup__coupon').querySelector('[data-coupon-code]');
        if (!codeEl) return;
        var code = codeEl.textContent.trim();

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            showCopied(btn);
          });
        } else {
          // フォールバック
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.cssText = 'position:fixed;left:-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          showCopied(btn);
        }
      });
    });
  }

  function showCopied(btn) {
    btn.setAttribute('data-copied', 'コピーしました');
    btn.textContent = 'コピー済み';
    setTimeout(function () {
      btn.removeAttribute('data-copied');
      btn.textContent = 'コピー';
    }, 2000);
  }

  /* ---------- フォーカストラップ ---------- */

  function trapFocus(root) {
    var focusable = root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return null;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    root.addEventListener('keydown', handler);
    first.focus();

    return function () {
      root.removeEventListener('keydown', handler);
    };
  }

  /* ========================================
   * ExitPopup メインクラス
   * ======================================== */

  function ExitPopup(el) {
    this.el = el;
    this.sectionId = el.dataset.sectionId;
    this.sensitivity = el.dataset.spSensitivity || 'medium';
    this.minStay = parseInt(el.dataset.minStay, 10) || 5;
    this.dayNext = parseInt(el.dataset.dayNext, 10);
    this.ppVersion = el.dataset.ppVersion || '1';

    this.isVisible = false;
    this.pageLoadTime = Date.now();
    this.detector = null;
    this.swipeHandler = null;
    this.removeFocusTrap = null;
    this.previousActiveElement = null;

    this._onKeyDown = this._onKeyDown.bind(this);
    this._show = this.show.bind(this);
    this._hide = this.hide.bind(this);

    this.init();
  }

  ExitPopup.prototype.init = function () {
    // デザインモード判定
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      this._initDesignMode();
      return;
    }

    // 表示条件チェック
    if (!this.checkDisplayCondition()) return;

    // デバイスに応じた検知を登録
    if (isMobile() || isTouchDevice()) {
      this.detector = new ScrollDetector({
        sensitivity: this.sensitivity,
        onTrigger: this._show
      });
    } else {
      this.detector = new MouseDetector({
        onTrigger: this._show
      });
    }

    // 最低滞在時間後に検知開始
    var self = this;
    this._stayTimer = setTimeout(function () {
      if (self.detector) self.detector.start();
    }, this.minStay * 1000);

    // イベント登録
    this._bindCloseEvents();
    initCouponCopy(this.el);
  };

  ExitPopup.prototype.checkDisplayCondition = function () {
    // バージョンチェック（バージョンが変わったら Cookie をリセット）
    var storedVersion = getCookie(COOKIE_NAME);
    if (storedVersion && storedVersion !== this.ppVersion) {
      // バージョンが変わったのでリセット
      setCookie(COOKIE_NAME, '', -1);
      sessionStorage.removeItem(SESSION_KEY);
    } else if (storedVersion === this.ppVersion) {
      // 同バージョンで既に表示済み
      return false;
    }

    // セッションチェック
    if (sessionStorage.getItem(SESSION_KEY) === this.ppVersion) {
      return false;
    }

    return true;
  };

  ExitPopup.prototype.show = function () {
    if (this.isVisible) return;

    // 最低滞在時間の再チェック
    var elapsed = Date.now() - this.pageLoadTime;
    if (elapsed < this.minStay * 1000) return;

    this.isVisible = true;
    this.previousActiveElement = document.activeElement;
    this.el.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // センターモード判定
    var isCenterMode = this.el.hasAttribute('data-center-mode');

    // SPのスワイプハンドラ起動（センターモード時はスキップ）
    if (!isCenterMode && (isMobile() || isTouchDevice())) {
      var sheet = this.el.querySelector('[data-exit-sheet]');
      if (sheet) {
        this.swipeHandler = new SwipeHandler(sheet, this._hide);
        this.swipeHandler.start();
      }
    }

    // Escキー
    document.addEventListener('keydown', this._onKeyDown);

    // フォーカストラップ
    var activeContainer;
    if (isCenterMode) {
      activeContainer = this.el.querySelector('.c-exit-popup__modal');
    } else {
      activeContainer = isMobile()
        ? this.el.querySelector('.c-exit-popup__sheet')
        : this.el.querySelector('.c-exit-popup__modal');
    }
    if (activeContainer) {
      this.removeFocusTrap = trapFocus(activeContainer);
    }
  };

  ExitPopup.prototype.hide = function () {
    if (!this.isVisible) return;
    this.isVisible = false;
    this.el.classList.remove('is-active');
    document.body.style.overflow = '';

    // Cookie & sessionStorage 設定
    if (this.dayNext > 0) {
      setCookie(COOKIE_NAME, this.ppVersion, this.dayNext);
    }
    sessionStorage.setItem(SESSION_KEY, this.ppVersion);

    // クリーンアップ
    if (this.swipeHandler) {
      this.swipeHandler.stop();
      this.swipeHandler = null;
    }
    document.removeEventListener('keydown', this._onKeyDown);
    if (this.removeFocusTrap) {
      this.removeFocusTrap();
      this.removeFocusTrap = null;
    }
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
      this.previousActiveElement = null;
    }

    // ボトムシートの transform をリセット
    var sheet = this.el.querySelector('[data-exit-sheet]');
    if (sheet) {
      sheet.style.transform = '';
    }
  };

  ExitPopup.prototype.destroy = function () {
    this.hide();
    if (this.detector) {
      this.detector.stop();
      this.detector = null;
    }
    if (this._stayTimer) {
      clearTimeout(this._stayTimer);
    }
  };

  ExitPopup.prototype._onKeyDown = function (e) {
    if (e.key === 'Escape') {
      this.hide();
    }
  };

  ExitPopup.prototype._bindCloseEvents = function () {
    var self = this;

    // 閉じるボタン
    var closeBtns = this.el.querySelectorAll('[data-exit-close]');
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', self._hide);
    });

    // オーバーレイクリック
    var overlay = this.el.querySelector('[data-exit-overlay]');
    if (overlay) {
      overlay.addEventListener('click', self._hide);
    }
  };

  /* ---------- デザインモード ---------- */

  ExitPopup.prototype._initDesignMode = function () {
    var self = this;

    initCouponCopy(this.el);
    this._bindCloseEvents();

    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail.sectionId === self.sectionId) self.show();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail.sectionId === self.sectionId) self.hide();
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.detail.sectionId === self.sectionId) self.show();
    });
  };

  /* ========================================
   * 初期化
   * ======================================== */

  function initExitPopup() {
    var el = document.querySelector('.c-exit-popup');
    if (el) {
      window.__cExitPopup = new ExitPopup(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExitPopup);
  } else {
    initExitPopup();
  }
})();
